/**
 * 聚水潭 ERP 第二章截图场景。
 *
 * 当前仅完成图片接入与步骤骨架，具体交互流程后续补充。
 */

import resendProvinces from '../../../../static/json/jst-provinces.json'
import resendCities from '../../../../static/json/jst-cities.json'
import resendDistricts from '../../../../static/json/jst-districts.json'
import {
  JST_TARGETS,
  JST_SECOND_ORDER_ROW,
  JST_SECOND_GOODS_ROWS,
  JST_ERROR_PRODUCT,
  JST_ERROR_PRODUCT_LIBRARY
} from './jstErpFixtureData'

import { br, red } from './jstTip'

function r(path) {
  return require('@/assets/images/jushuitan/' + path)
}

const TARGET_ORDER_CODE = JST_TARGETS.serviceOrder
const TARGET_ORDER_NO = JST_SECOND_ORDER_ROW.orderNo
const ERROR_PRODUCT_STYLE_CODE = JST_ERROR_PRODUCT.styleCode
const EXCHANGE_RECEIVER_TEXT = '朱小明 13800138000 陕西省西安市雁塔区丈八街道丹轩梓园3号楼'
const DOMESTIC_EXPRESS_COMPANIES = [
  'EMS', '邮政快递包裹', '顺丰速运', '顺丰同城', '京东快递', '中通快递', '圆通速递', '申通快递', '韵达快递', '极兔速递',
  '德邦快递', '菜鸟速递', '百世快递'
]
const DIRECT_CONTROLLED_MUNICIPALITIES = ['北京市', '天津市', '上海市', '重庆市']

function findResendProvince(provinceName) {
  return resendProvinces.find(item => item.name === provinceName)
}

function getResendCities(provinceName) {
  const province = findResendProvince(provinceName)
  if (!province) return []
  if (DIRECT_CONTROLLED_MUNICIPALITIES.indexOf(provinceName) > -1) return [provinceName]
  return resendCities.filter(item => item.province === province.province).map(item => item.name)
}

function getResendDistricts(provinceName, cityName) {
  const province = findResendProvince(provinceName)
  if (!province || !cityName) return []
  if (DIRECT_CONTROLLED_MUNICIPALITIES.indexOf(provinceName) > -1) {
    return resendDistricts.filter(item => item.province === province.province).map(item => item.name)
  }
  const city = resendCities.find(item => item.province === province.province && item.name === cityName)
  return city ? resendDistricts.filter(item => item.province === province.province && item.city === city.city).map(item => item.name) : []
}
const ERROR_PRODUCT = JST_ERROR_PRODUCT
const ERROR_PRODUCT_LIBRARY = JST_ERROR_PRODUCT_LIBRARY
const MOCK_ORDER_ROWS = [JST_SECOND_ORDER_ROW]
const MOCK_GOODS_ROWS = JST_SECOND_GOODS_ROWS

const EXCHANGE_PRODUCT = {
  ...MOCK_GOODS_ROWS[0], id: 'exchange-product-goods-1', type: '换', typeColor: '#409eff', issueType: '无', issueTypeLocked: true
}

const DEFAULT_ORDER_TABLE_POSITION = { x: 0.14, y: 0.21, w: 0.848, h: 0.15 }
const DEFAULT_GOODS_TABLE_POSITION = { x: 0.14, y: 0.51, w: 0.848, h: 0.17 }
const _54_GOODS_TABLE_POSITION = { x: 0.14, y: 0.54, w: 0.848, h: 0.17 }


function buildTables({ ui }, goodsTablePosition = DEFAULT_GOODS_TABLE_POSITION, options = {}) {
  // const searched = ui.searchSearched
  // const orderCode = (form.orderCode || '').trim()

  // 未查询或订单号不匹配，不展示表格
  // if (!searched || orderCode !== TARGET_ORDER_CODE) return []

  // 合并商品草稿：用户编辑的单价、数量、金额
  const draft = ui.goodsTableDraft || {}
  const sourceRows = MOCK_GOODS_ROWS.concat(options.additionalGoods || [])
  const orderSelected = (ui['order-tableSelectedKeys'] || []).includes(MOCK_ORDER_ROWS[0].id)
  const goodsRows = sourceRows.map(row => {
    const cellDraft = draft[row.id]
    const rowDefaults = typeof options.rowDefaults === 'function' ? options.rowDefaults(row) : (options.rowDefaults || {})
    return {
      ...row,
      type: options.goodsType || row.type,
      typeColor: options.goodsTypeColor || row.typeColor,
      ...(options.defaultQty !== undefined ? { qty: options.defaultQty } : {}),
      ...(options.defaultAmount !== undefined ? { amount: options.defaultAmount } : {}),
      ...rowDefaults,
      ...(cellDraft || {})
    }
  })

  return [
    // ── 上表：订单搜索结果 ──
    {
      id: 'order-table',
      ...DEFAULT_ORDER_TABLE_POSITION,
      rows: MOCK_ORDER_ROWS,
      columns: [
        { key: 'orderNo', title: '订单号', width: 100 },
        { key: 'orderTime', title: '下单时间', width: 126 },
        { key: 'buyerNickname', title: '买家昵称', width: 92 },
        { key: 'receiver', title: '收货人', width: 260 },
        { key: 'shop', title: '店铺', width: 140 },
        { key: 'status', title: '状态', width: 92 },
        { key: 'orderCode', title: '线上订单号', width: 168 },
        { key: 'payAmount', title: '买家下单金额', width: 120, align: 'right' },
        { key: 'orderType', title: '订单类型', width: 100 },
        { key: 'expressInfo', title: '快递信息', width: 140 },
        { key: 'buyerMessage', title: '买家留言', width: 100 },
        { key: 'buyerRemark', title: '卖家备注', width: 100 }
      ],
      rowKey: 'id',
      selectable: true,
      selectionType: 'radio',
      selectedKeys: []
    },
    // ── 下表：商品售后明细 ──
    {
      id: 'goods-table',
      ...goodsTablePosition,
      rows: orderSelected ? goodsRows : [],
      columns: [
        { key: 'image', type: 'image', title: '商品图片', width: 74 },
        { key: 'goodsCode', title: '商品编码', width: options.wideDetailColumns ? 236 : 118 },
        { key: 'styleCode', title: '款式编码', width: 100 },
        { key: 'goodsName', title: '商品名称', width: options.wideDetailColumns ? 300 : 150 },
        { key: 'goodsShortName', title: '商品简称', width: options.wideDetailColumns ? 290 : 145 },
        { key: 'spec', title: '颜色及规格', width: options.wideDetailColumns ? 260 : 130 },
        { key: 'type', title: '类型', width: 58, cellStyle: row => row.typeColor ? { color: row.typeColor, fontWeight: '600' } : {} },
        ...(options.issueTypeColumn ? [{ key: 'issueType', type: 'select', title: '明细问题类型', width: options.wideDetailColumns ? 240 : 120, options: ['应发未发', '无', '错发已发'], inputDisabled: row => row.issueTypeLocked === true }] : []),
        { key: 'price', type: 'input', title: options.priceTitle || '单价', width: options.wideDetailColumns ? 176 : 88, align: 'right' },
        { key: 'qty', type: 'input', title: options.qtyTitle || '退货数量', width: 96, align: 'right' },
        { key: 'amount', type: 'input', title: options.amountTitle || '退货金额', width: 100, align: 'right', inputDisabled: options.amountInputDisabled === true },
        { key: 'appliedReturnQty', title: '已申请退货', width: 100, align: 'right' },
        { key: 'actualReturnQty', title: '实际退货', width: 90, align: 'right' },
        { key: 'goodsAmount', title: '商品金额', width: 90, align: 'right' },
        { key: 'orderQty', title: '订单数', width: 72, align: 'right' }
      ],
      rowKey: 'id',
      selectable: true,
      selectedKeys: [],
      selectionDisabled: options.goodsSelectionDisabled === true,
      onCellChange: ({ row, key, value, ui, setUi }) => {
        const draft = { ...(ui.goodsTableDraft || {}) }
        const rowId = row.id
        draft[rowId] = { ...(draft[rowId] || {}), [key]: value }
        setUi({ goodsTableDraft: draft })
      }
    }
  ]
}

function requireOrderSelection({ ui }) {
  return (ui['order-tableSelectedKeys'] || []).includes(MOCK_ORDER_ROWS[0].id)
    ? { ok: true }
    : { ok: false, msg: '请先选中搜索出的订单' }
}

function buildCreatedTables({ ui }) {
  const rows = ui.createdOrders || []
  if (!rows.length) return []
  return [{
    id: 'created-aftersale-table',
    x: 0.04, y: 0.63, w: 0.948, h: 0.33,
    rows,
    columns: [
      { key: 'serialNo', title: '序号', width: 56, align: 'center' },
      { key: 'aftersaleNo', title: '售后单号', width: 160 },
      { key: 'internalOrderNo', title: '内部订单号', width: 130 },
      { key: 'aftersaleStatus', title: '售后单状态', width: 110 },
      { key: 'solution', title: '解决方案', width: 120 },
      { key: 'onlineStatus', title: '线上状态', width: 130 },
      { key: 'onlineType', title: '线上类型', width: 100 },
      { key: 'aftersaleCategory', title: '售后分类', width: 110 },
      { key: 'goodsInfo', title: '商品信息', width: 200, whiteSpace: 'pre-line' },
      { key: 'returnWaybill', title: '退货快递单号', width: 150 },
      { key: 'returnInternationalWaybill', title: '退货国际单号', width: 150 },
      { key: 'cargoStatus', title: '货物状态', width: 130 },
      { key: 'expressInterceptStatus', title: '快递拦截状态', width: 140 },
      { key: 'operation', title: '操作', width: 100, whiteSpace: 'pre-line' }
    ],
    rowKey: 'aftersaleNo',
    selectable: true,
    selectedKeys: []
  }]
}

function buildReturnFields() {
  return [
    { id: 'return-express', model: 'returnExpress', type: 'text', bgColor: '#fff', fontSize: 10, placeholder: '请输入', x: 0.21, y: 0.695, w: 0.14, h: 0.026 },
    { id: 'return-waybill', model: 'returnWaybill', type: 'text', bgColor: '#fff', fontSize: 10, placeholder: '请输入', x: 0.42, y: 0.695, w: 0.14, h: 0.026 },
    { id: 'return-warehouse', model: 'returnWarehouse', type: 'select', bgColor: '#fff', fontSize: 10, placeholder: '请选择', options: ['淘金仓库'], x: 0.60, y: 0.695, w: 0.17, h: 0.026 },
    { id: 'remark', model: 'remark', type: 'text', bgColor: '#fff', fontSize: 10, placeholder: '请输入备注', x: 0.16, y: 0.735, w: 0.19, h: 0.026 },
    { id: 'buyer-subsidy', model: 'buyerSubsidy', type: 'text', bgColor: '#fff', fontSize: 10, placeholder: '请输入', x: 0.405, y: 0.735, w: 0.15, h: 0.026 }
  ]
}

function buildErrorReturnTables(context) {
  const addedGoods = context.ui.errorAddedGoods || []
  return buildTables(context, DEFAULT_GOODS_TABLE_POSITION, {
    issueTypeColumn: true,
    additionalGoods: addedGoods
  })
}

function buildErrorExchangeTables(context) {
  return buildTables(context, DEFAULT_GOODS_TABLE_POSITION, {
    issueTypeColumn: true,
    additionalGoods: (context.ui.errorAddedGoods || []).concat(context.ui.exchangeAddedGoods || []),
    qtyTitle: '本次退换数量',
    amountTitle: '退换金额'
  })
}

function fillBuyerAddress(value, setForm, nextTick, prefix, phoneModel) {
  const normalizedValue = String(value || '').replace(/\s+/g, '')
  const normalizedReceiver = EXCHANGE_RECEIVER_TEXT.replace(/\s+/g, '')
  if (normalizedValue !== normalizedReceiver) return
  const province = prefix + 'Province'
  const city = prefix + 'City'
  const district = prefix + 'District'
  const detail = prefix + 'Detail'
  const receiver = prefix + 'Receiver'
  const phone = phoneModel || prefix + 'Phone'
  setForm({ [province]: '陕西省', [city]: '', [district]: '', [detail]: '丈八街道丹轩梓园3号楼', [receiver]: '朱小明', [phone]: '13800138000' })
  nextTick(() => {
    setForm({ [city]: '西安市', [district]: '' })
    nextTick(() => setForm({ [district]: '雁塔区' }))
  })
}

function buildErrorExchangeFields(form = {}) {
  const provinceOptions = resendProvinces.map(item => item.name)
  const cityOptions = getResendCities(form.buyerProvince)
  const districtOptions = getResendDistricts(form.buyerProvince, form.buyerCity)
  return [
    ...buildReturnFields(),
    { id: 'out-express', model: 'outExpress', type: 'select', bgColor: '#fff', fontSize: 10, placeholder: '请选择', options: DOMESTIC_EXPRESS_COMPANIES, x: 0.812, y: 0.7333, w: 0.169, h: 0.025 },
    { id: 'buyer-province', model: 'buyerProvince', type: 'select', bgColor: '#fff', fontSize: 10, placeholder: '省份', options: provinceOptions, x: 0.21, y: 0.771, w: 0.044, h: 0.028,
      onInput: ({ setForm }) => setForm({ buyerCity: '', buyerDistrict: '' }) },
    { id: 'buyer-city', model: 'buyerCity', type: 'select', bgColor: '#fff', fontSize: 10, placeholder: '城市', options: cityOptions, x: 0.258, y: 0.771, w: 0.044, h: 0.028,
      onInput: ({ setForm }) => setForm({ buyerDistrict: '' }) },
    { id: 'buyer-district', model: 'buyerDistrict', type: 'select', bgColor: '#fff', fontSize: 10, placeholder: '区县', options: districtOptions, x: 0.306, y: 0.771, w: 0.044, h: 0.028 },
    { id: 'buyer-detail', model: 'buyerDetail', type: 'text', bgColor: '#fff', fontSize: 10, placeholder: '详细地址', x: 0.356, y: 0.771, w: 0.207, h: 0.028 },
    { id: 'buyer-receiver', model: 'buyerReceiver', type: 'text', bgColor: '#fff', fontSize: 10, placeholder: '收货人', x: 0.567, y: 0.771, w: 0.10, h: 0.028 },
    { id: 'buyer-phone', model: 'buyerReceiverPhone', type: 'text', bgColor: '#fff', fontSize: 10, placeholder: '联系电话', x: 0.671, y: 0.771, w: 0.101, h: 0.028 },
    { id: 'receiver-smart-input', model: 'receiverSmartInput', type: 'text', bgColor: '#fff', fontSize: 10, placeholder: '粘贴或输入收件人信息回车后系统自动识别', x: 0.8164, y: 0.771, w: 0.1563, h: 0.027,
      onInput: ({ value, setForm, nextTick }) => fillBuyerAddress(value, setForm, nextTick, 'buyer', 'buyerReceiverPhone') }
  ]
}

function buildRepairFields(form = {}) {
  return buildErrorExchangeFields(form).filter(field => field.id !== 'out-express')
}

function buildResendFields(form = {}) {
  const provinceOptions = resendProvinces.map(item => item.name)
  const cityOptions = getResendCities(form.resendBuyerProvince)
  const districtOptions = getResendDistricts(form.resendBuyerProvince, form.resendBuyerCity)
  return [
    { id: 'resend-remark', model: 'resendRemark', type: 'text', bgColor: '#fff', fontSize: 9, placeholder: '请输入', x: 0.165, y: 0.736, w: 0.182, h: 0.022 },
    { id: 'resend-buyer-subsidy', model: 'resendBuyerSubsidy', type: 'text', bgColor: '#fff', fontSize: 9, placeholder: '请输入', x: 0.405, y: 0.736, w: 0.157, h: 0.022 },
    { id: 'resend-out-express', model: 'resendOutExpress', type: 'select', bgColor: '#fff', fontSize: 9, placeholder: '请选择', options: DOMESTIC_EXPRESS_COMPANIES, x: 0.602, y: 0.736, w: 0.168, h: 0.022 },
    { id: 'resend-buyer-province', model: 'resendBuyerProvince', type: 'select', bgColor: '#fff', fontSize: 9, placeholder: '省份', options: provinceOptions, x: 0.839, y: 0.736, w: 0.046, h: 0.022,
      onInput: ({ setForm }) => setForm({ resendBuyerCity: '', resendBuyerDistrict: '' }) },
    { id: 'resend-buyer-city', model: 'resendBuyerCity', type: 'select', bgColor: '#fff', fontSize: 9, placeholder: '城市', options: cityOptions, x: 0.887, y: 0.736, w: 0.046, h: 0.022,
      onInput: ({ setForm }) => setForm({ resendBuyerDistrict: '' }) },
    { id: 'resend-buyer-district', model: 'resendBuyerDistrict', type: 'select', bgColor: '#fff', fontSize: 9, placeholder: '区县', options: districtOptions, x: 0.935, y: 0.736, w: 0.048, h: 0.022 },
    { id: 'resend-buyer-detail', model: 'resendBuyerDetail', type: 'text', bgColor: '#fff', fontSize: 9, placeholder: '详细地址', x: 0.146, y: 0.775, w: 0.205, h: 0.022 },
    { id: 'resend-buyer-receiver', model: 'resendBuyerReceiver', type: 'text', bgColor: '#fff', fontSize: 9, placeholder: '收货人', x: 0.357, y: 0.775, w: 0.101, h: 0.022 },
    { id: 'resend-buyer-phone', model: 'resendBuyerPhone', type: 'text', bgColor: '#fff', fontSize: 9, placeholder: '联系电话', x: 0.462, y: 0.775, w: 0.10, h: 0.022 },
    { id: 'resend-smart-input', model: 'resendSmartInput', type: 'text', bgColor: '#fff', fontSize: 9, placeholder: '粘贴或输入收件人信息回车后系统自动识别', x: 0.602, y: 0.775, w: 0.171, h: 0.022,
      onInput: ({ value, setForm, nextTick }) => {
        const normalizedValue = String(value || '').replace(/\s+/g, '')
        const normalizedReceiver = EXCHANGE_RECEIVER_TEXT.replace(/\s+/g, '')
        if (normalizedValue !== normalizedReceiver) return
        setForm({ resendBuyerProvince: '陕西省', resendBuyerCity: '', resendBuyerDistrict: '', resendBuyerDetail: '丈八街道丹轩梓园3号楼', resendBuyerReceiver: '朱小明', resendBuyerPhone: '13800138000' })
        nextTick(() => {
          setForm({ resendBuyerCity: '西安市', resendBuyerDistrict: '' })
          nextTick(() => setForm({ resendBuyerDistrict: '雁塔区' }))
        })
      } }
  ]
}

function buildLeakResendTables(context, beforeIssueSelection = false) {
  return buildTables(context, _54_GOODS_TABLE_POSITION, {
    goodsType: '补',
    goodsTypeColor: '#e6a23c',
    issueTypeColumn: true,
    qtyTitle: '本次补发数量',
    amountTitle: '补发金额',
    defaultAmount: 0,
    amountInputDisabled: true,
    rowDefaults: row => beforeIssueSelection
      ? { qty: 1, issueType: '' }
      : (row.id === 'goods-1'
        ? { qty: 1, issueType: '' }
        : { qty: 0, issueType: '' })
  })
}

function buildLeakResendFields(form = {}) {
  const provinceOptions = resendProvinces.map(item => item.name)
  const cityOptions = getResendCities(form.leakBuyerProvince)
  const districtOptions = getResendDistricts(form.leakBuyerProvince, form.leakBuyerCity)
  return [
    { id: 'leak-remark', model: 'leakRemark', type: 'text', bgColor: '#fff', fontSize: 10, placeholder: '请输入', x: 0.165, y: 0.732, w: 0.187, h: 0.028 },
    { id: 'leak-buyer-subsidy', model: 'leakBuyerSubsidy', type: 'text', bgColor: '#fff', fontSize: 10, placeholder: '请输入', x: 0.405, y: 0.732, w: 0.157, h: 0.028 },
    { id: 'leak-out-express', model: 'leakOutExpress', type: 'select', bgColor: '#fff', fontSize: 10, placeholder: '请选择', options: DOMESTIC_EXPRESS_COMPANIES, x: 0.601, y: 0.732, w: 0.171, h: 0.028 },
    { id: 'leak-buyer-province', model: 'leakBuyerProvince', type: 'select', bgColor: '#fff', fontSize: 10, placeholder: '省份', options: provinceOptions, x: 0.839, y: 0.732, w: 0.045, h: 0.028,
      onInput: ({ setForm }) => setForm({ leakBuyerCity: '', leakBuyerDistrict: '' }) },
    { id: 'leak-buyer-city', model: 'leakBuyerCity', type: 'select', bgColor: '#fff', fontSize: 10, placeholder: '城市', options: cityOptions, x: 0.888, y: 0.732, w: 0.045, h: 0.028,
      onInput: ({ setForm }) => setForm({ leakBuyerDistrict: '' }) },
    { id: 'leak-buyer-district', model: 'leakBuyerDistrict', type: 'select', bgColor: '#fff', fontSize: 10, placeholder: '区县', options: districtOptions, x: 0.937, y: 0.732, w: 0.046, h: 0.028 },
    { id: 'leak-buyer-detail', model: 'leakBuyerDetail', type: 'text', bgColor: '#fff', fontSize: 10, placeholder: '详细地址', x: 0.145, y: 0.771, w: 0.207, h: 0.028 },
    { id: 'leak-buyer-receiver', model: 'leakBuyerReceiver', type: 'text', bgColor: '#fff', fontSize: 10, placeholder: '收货人', x: 0.356, y: 0.771, w: 0.101, h: 0.028 },
    { id: 'leak-buyer-phone', model: 'leakBuyerPhone', type: 'text', bgColor: '#fff', fontSize: 10, placeholder: '联系电话', x: 0.461, y: 0.771, w: 0.10, h: 0.028 },
    { id: 'leak-smart-input', model: 'leakSmartInput', type: 'text', bgColor: '#fff', fontSize: 10, placeholder: '粘贴或输入收件人信息回车后系统自动识别', x: 0.601, y: 0.771, w: 0.171, h: 0.028,
      onInput: ({ value, setForm, nextTick }) => fillBuyerAddress(value, setForm, nextTick, 'leakBuyer') }
  ]
}

function buildProductSearchTable(searched) {
  return [{
    id: 'error-product-search-table', x: 0.214, y: 0.376, w: 0.60, h: searched ? 0.20 : 0.34,
    rows: searched ? [ERROR_PRODUCT] : ERROR_PRODUCT_LIBRARY, rowKey: 'id', selectable: true, selectedKeys: [],
    columns: [
      { key: 'goodsName', title: '商品名称', width: 210 },
      { key: 'goodsShortName', title: '商品简称', width: 160 },
      { key: 'qty', type: 'input', title: '数量', width: 100 },
      { key: 'price', title: '单价', width: 90 },
      { key: 'goodsCode', title: '商品编码', width: 160 },
      { key: 'styleCode', title: '款式编码', width: 110 },
      { key: 'spec', title: '颜色及规格', width: 120 }
    ]
  }]
}

function buildExchangeProductSelectTable() {
  return [{
    id: 'exchange-product-select-table', x: 0.214, y: 0.25, w: 0.60, h: 0.17,
    rows: MOCK_GOODS_ROWS, rowKey: 'id', selectable: true, selectedKeys: [],
    columns: [
      { key: 'image', type: 'image', title: '图片', width: 70 }, { key: 'goodsName', title: '商品名称', width: 260 },
      { key: 'goodsCode', title: '商品编码', width: 150 }, { key: 'styleCode', title: '款式编码', width: 120 },
      { key: 'spec', title: '颜色及规格', width: 150 }, { key: 'qty', title: '数量', width: 80 }, { key: 'price', title: '单价', width: 80 }
    ]
  }]
}

function productSearchLabels({ ui }) {
  const selected = ui['error-product-search-tableSelectedKeys'] || []
  const codes = ERROR_PRODUCT_LIBRARY.filter(row => selected.includes(row.id)).map(row => row.goodsCode)
  return [
    { id: 'error-product-count', text: String(selected.length), color: '#5045a8', fontSize: 12, bgColor: '#fff', x: 0.256, y: 0.344, w: 0.02, h: 0.02 },
    { id: 'error-product-codes', text: codes.join('，'), color: '#5045a8', fontSize: 12, bgColor: '#fff', justifyContent: 'flex-start', x: 0.28, y: 0.344, w: 0.52, h: 0.02 }
  ]
}

const SCENE_IMAGES = {
  fastEmpty: r('1-2.png'),
  fast: r('2-0-aftersale-fast.png'),
  order: r('2-0-order.png'),
  search: r('2-1-search.png'),
  resend: r('2-4-普通补发.png'),
  repair: r('2-5-普通维修.png'),
  errorReturnRefund: r('2-7-错发退货退款.png'),
  errorExchange: r('2-9-错发换货.png'),
  leakBusiness: r('ppt/2-18-漏发补发问题类型.png'),
  leakResend: r('ppt/2-21-漏发补发建单.png'),
  errorProductSearch: r('ppt/2-16-错发退货退款问题选择.png'),
  errorProductSearchResult: r('ppt/2-17-错发退货退款商品库.png'),
  exchangeProductSelect: r('ppt/2-34-错发换货选择订单商品.png')
}

const EMPTY_RETURN_FORM = { returnExpress: '', returnWaybill: '', returnWarehouse: '', remark: '', buyerSubsidy: '' }
const EMPTY_RECEIVER_FORM = { buyerProvince: '', buyerCity: '', buyerDistrict: '', buyerDetail: '', buyerReceiver: '', buyerReceiverPhone: '', receiverSmartInput: '' }
const EMPTY_RESEND_FORM = { resendRemark: '', resendBuyerSubsidy: '', resendOutExpress: '', resendBuyerProvince: '', resendBuyerCity: '', resendBuyerDistrict: '', resendBuyerDetail: '', resendBuyerReceiver: '', resendBuyerPhone: '', resendSmartInput: '' }
const EMPTY_ERROR_EXCHANGE_FORM = { ...EMPTY_RETURN_FORM, ...EMPTY_RECEIVER_FORM, outExpress: '' }
const EMPTY_LEAK_RESEND_FORM = { leakRemark: '', leakBuyerSubsidy: '', leakOutExpress: '', leakBuyerProvince: '', leakBuyerCity: '', leakBuyerDistrict: '', leakBuyerDetail: '', leakBuyerReceiver: '', leakBuyerPhone: '', leakSmartInput: '' }
const SECOND_CHAPTER_TIPS = [
  '线上订单号为' + red('5124299977002014714') + '的订单中商品编码为' + red('TEST-GD-0001') + '的商品，买家需要退回，原因是' + red('买错了') + '，符合' + red('7天无理由退回') + '场景，现已寄回商品，邮费由' + red('买家承担') + '，需创建新的售后单。' + br() + '快递信息：' + red('申通快递') + '，单号' + red('st12654458855') + '。',
  '手机号' + red('115680518989') + '关联的订单商品' + red('TEST-GD-0001') + '破损需要补发' + red('1件') + '。' + br() + '卖家将使用' + red('京东快递') + '寄出，买家收货信息“' + red(EXCHANGE_RECEIVER_TEXT) + '”。',
  '订单号' + red('381499') + '关联的商品维修' + red('TEST-GD-0001') + '，需要寄回维修，维修金额' + red('99元') + '。' + br() + '买家现已使用' + red('申通快递') + '寄回商品，单号为' + red('st12654458855') + '，寄回仓库为' + red('淘金仓库') + '，维修好后再寄给买家，需买家承担邮费' + red('8元') + '。' + br() + '买家收货地址：' + red(EXCHANGE_RECEIVER_TEXT),
  '线上订单号 ' + red('5124299977002014714') + '关联的商品' + red('TEST-GD-0001') + red('未发') + '，错发了商品' + red('STY-BSK-001') + '。' + br() + '买家已使用' + red('申通快递') + '退回错发商品，' + red('st12654458855') + '，退回' + red('淘金仓库') + '。',
  '线上订单号' + red('5124299977002014714') + '关联的商品' + red('TEST-GD-0001') + '的商品' + red('应发未发') + '，错发了商品' + red('STY-BSK-001') + '。买家已使用' + red('申通快递') + '退回错发商品，' + red('st12654458855') + '，退回' + red('淘金仓库') + '，同时需使用' + red('京东快递') + '寄出未发商品，买家收件地址为：' + red(EXCHANGE_RECEIVER_TEXT),
  '线上订单号' + red('5124299977002014714') + '关联商品' + red('漏发') + '，需要' + red('补发') + '。' + br() + '卖家将使用' + red('京东快递') + '寄出，买家收货地址为：' + red(EXCHANGE_RECEIVER_TEXT)
]
function getSecondChapterTip({ ui }) {
  const createdCount = (ui.createdOrders || []).length
  return SECOND_CHAPTER_TIPS[Math.min(createdCount, SECOND_CHAPTER_TIPS.length - 1)]
}

const SECOND_CHAPTER_STEPS = [
  {
    id: 'fasts',
    image: ({ ui }) => (ui.createdOrders || []).length ? SCENE_IMAGES.fast : SCENE_IMAGES.fastEmpty,
    tip: ({ ui }) => ui.leakFlowCompleted
      ? '<span style="color:red;font-weight:bold;">漏发补发售后单已创建，本流程已完成。</span>'
      : '<span style="color:red;font-weight:bold;">手工创建售后单</span>',
    tables: buildCreatedTables,
    hotspots: ({ ui }) => ui.leakFlowCompleted ? [] : [{
      id: 'addOrderButton',
      x: 0.8055, y: 0.52, w: 0.08, h: 0.03,
      highlight: 'primary',
      set: { 'order-tableSelectedKeys': [], 'order-tableSelectedRows': [], 'goods-tableSelectedKeys': [], 'goods-tableSelectedRows': [], goodsTableDraft: {} },
      setForm: { orderCode: '', orderNo: '', buyerPhone: '' },
      next: 'order'
    }]
  },
  {
    id: 'fasts-complete',
    image: SCENE_IMAGES.fast,
    tip: '<span style="color:red;font-weight:bold;">漏发补发售后单已创建，本流程已完成。</span>',
    tables: buildCreatedTables,
    hotspots: [],
    isEnd: true
  },
  {
    id: 'order',
    image: SCENE_IMAGES.order,
    tip: ({ ui }) => {
      const count = (ui.createdOrders || []).length
      if (count === 1) return '查询手机号为<span style="color:red;font-weight:bold;">115680518989</span>的订单，并创建<span style="color:red;font-weight:bold;">普通业务类型-仅退款</span>售后单'
      if (count === 2) return '搜索<span style="color:red;font-weight:bold;">订单号为' + TARGET_ORDER_NO + '</span>的订单。'
      return '搜索<span style="color:red;font-weight:bold;">线上订单号为' + TARGET_ORDER_CODE + '</span>的订单，并创建<span style="color:red;font-weight:bold;">普通业务类型-退货退款</span>售后单'
    },
    fields: ({ ui }) => {
      const count = (ui.createdOrders || []).length
      if (count === 1) return [{ id: 'buyer-phone', model: 'buyerPhone', type: 'text', bgColor: '#FFFFFF', fontSize: 10, placeholder: '多个手机号，以逗号分隔', x: 0.25, y: 0.122, w: 0.085, h: 0.02 }]
      if (count === 2) return [{ id: 'order-no', model: 'orderNo', type: 'text', bgColor: '#FFFFFF', fontSize: 10, placeholder: '多个订单号，以逗...', x: 0.355, y: 0.122, w: 0.085, h: 0.02 }]
      return [{ id: 'order-code', model: 'orderCode', type: 'text', bgColor: '#FFFFFF', fontSize: 10, placeholder: '多个线上订单号，...', x: 0.465, y: 0.122, w: 0.08, h: 0.02 }]
    },
    hotspots: [
      {
        id: 'search-btn-order',
        x: 0.915, y: 0.154,
        w: 0.03, h: 0.03,
        highlight: 'primary',
        guard: ({ ui, form }) => (ui.createdOrders || []).length === 1
          ? (form.buyerPhone === '115680518989' ? { ok: true } : { ok: false, msg: '请输入手机号 115680518989' })
          : ((ui.createdOrders || []).length === 2
            ? ((form.orderNo || '').trim() === TARGET_ORDER_NO
              ? { ok: true }
              : { ok: false, msg: '请输入正确的订单号 ' + TARGET_ORDER_NO })
            : ((form.orderCode || '').trim() === TARGET_ORDER_CODE
              ? { ok: true }
              : { ok: false, msg: '请输入正确的线上订单号 ' + TARGET_ORDER_CODE })),
        set: { 'order-tableSelectedKeys': [], 'order-tableSelectedRows': [], 'goods-tableSelectedKeys': [], 'goods-tableSelectedRows': [], goodsTableDraft: {} },
        setForm: EMPTY_RETURN_FORM,
        next: 'search'
      }
    ]
  },
  {
    id: 'search',
    image: SCENE_IMAGES.search,
    tip: ({ ui }) => {
      const count = (ui.createdOrders || []).length
      if (count === 0) return '退货场景：买家要求<span style="color:red;font-weight:bold;">无理由退货</span>，选中要退货的商品（商品编码：<span style="color:red;font-weight:bold;">' + MOCK_GOODS_ROWS[0].goodsCode + '</span>），填入买家退回快递信息：<span style="color:red;font-weight:bold;">申通快递</span>，单号<span style="color:red;font-weight:bold;">st12654458855</span>。备注：<span style="color:red;font-weight:bold;">7天无理由</span>，买家应补运费<span style="color:red;font-weight:bold;">8元</span>。'
      if (count === 1) return '查看<span style="color:red;font-weight:bold;">普通业务类型-仅退款</span>的售后分类。'
      if (count === 3) return '查看<span style="color:red;font-weight:bold;">错发业务类型-退货退款</span>的售后分类。'
      return '查看<span style="color:red;font-weight:bold;">普通业务类型-拒收退货</span>的售后分类。'
    },
    fields: ({ ui }) => (ui.createdOrders || []).length === 1
      ? [{ id: 'search-phone', model: 'buyerPhone', type: 'text', bgColor: '#FFFFFF', fontSize: 10, placeholder: '多个手机号，以逗号分隔', x: 0.25, y: 0.122, w: 0.085, h: 0.02 }]
      : [
        ...((ui.createdOrders || []).length === 2
          ? [{ id: 'search-order-no', model: 'orderNo', type: 'text', bgColor: '#FFFFFF', fontSize: 11, placeholder: '多个订单号，以逗...', x: 0.355, y: 0.122, w: 0.085, h: 0.02 }]
          : [{ id: 'search-code', model: 'orderCode', type: 'text', bgColor: '#FFFFFF', fontSize: 11, placeholder: '多个线上订单号，...', x: 0.465, y: 0.122, w: 0.08, h: 0.02 }]),
        ...((ui.createdOrders || []).length === 0 ? buildReturnFields() : []),
      ],
    tables: context => buildTables(context, DEFAULT_GOODS_TABLE_POSITION, {
      goodsSelectionDisabled: (context.ui.createdOrders || []).length === 1
    }),
    hotspots: ({ ui }) => [
      ...((ui.createdOrders || []).length === 0 ? [{
        id: 'search-btn-search',
        x: 0.915, y: 0.154,
        w: 0.03, h: 0.03,
        highlight: 'primary',
        guard: ({ form }) => {
          const code = (form.orderCode || '').trim()
          if (!code) return { ok: false, msg: '请输入线上订单号' }
          if (code !== TARGET_ORDER_CODE) return { ok: false, msg: '请输入正确的线上订单号 ' + TARGET_ORDER_CODE }
          return { ok: true }
        },
        set: { searchSearched: true }
      }] : []),
      ...((ui.createdOrders || []).length === 1 ? [{
        id: 'select-ordinary-resend',
        x: 0.335, y: 0.42, w: 0.04, h: 0.03,
        highlight: 'primary',
        guard: requireOrderSelection,
        setForm: EMPTY_RESEND_FORM,
        next: 'resend'
      }] : []),
      ...((ui.createdOrders || []).length === 2 ? [{
        id: 'select-ordinary-repair',
        x: 0.38, y: 0.42, w: 0.04, h: 0.03,
        highlight: 'primary',
        guard: requireOrderSelection,
        set: { 'goods-tableSelectedKeys': [], goodsTableDraft: {} },
        setForm: { ...EMPTY_RETURN_FORM, ...EMPTY_RECEIVER_FORM },
        next: 'repair'
      }] : []),
      ...((ui.createdOrders || []).length === 3 ? [{
        id: 'select-error-business',
        x: 0.205, y: 0.36, w: 0.075, h: 0.04,
        highlight: 'primary',
        guard: requireOrderSelection,
        setForm: EMPTY_RETURN_FORM,
        next: 'error-return-refund'
      }] : []),
      ...((ui.createdOrders || []).length === 4 ? [{
        id: 'select-error-business-refund',
        x: 0.205, y: 0.36, w: 0.075, h: 0.04,
        highlight: 'primary',
        guard: requireOrderSelection,
        next: 'error-business-refund'
      }] : []),
      ...((ui.createdOrders || []).length === 5 ? [{
        id: 'select-leak-business',
        x: 0.281, y: 0.36, w: 0.078, h: 0.04,
        highlight: 'primary',
        guard: requireOrderSelection,
        next: 'leak-business'
      }] : []),
      ...((ui.createdOrders || []).length === 0 ? [{
        id: 'create-ordinary-return',
        x: 0.956, y: 0.962, w: 0.036, h: 0.032,
        highlight: 'primary',
        guard: ({ ui, form }) => {
          if (!(ui['goods-tableSelectedKeys'] || []).includes('goods-1')) return { ok: false, msg: '请选中要退货的商品' }
          const required = ['returnExpress', 'returnWaybill', 'returnWarehouse']
          if (required.some(key => !String(form[key] || '').trim())) return { ok: false, msg: '请完成退货快递和仓库信息' }
          const buyerSubsidy = String(form.buyerSubsidy || '').trim()
          if (buyerSubsidy && buyerSubsidy !== '0') return { ok: false, msg: '邮费由买家承担，请填写0' }
          return { ok: true }
        },
        action: ({ ui, form }) => {
          const drafts = ui.goodsTableDraft || {}
          const firstGoods = { ...MOCK_GOODS_ROWS[0], ...(drafts['goods-1'] || {}) }
          return {
            set: {
              createdOrders: (ui.createdOrders || []).concat({
                serialNo: (ui.createdOrders || []).length + 1,
                aftersaleNo: '售后单号：SH' + String((ui.createdOrders || []).length + 1).padStart(6, '0'),
                internalOrderNo: MOCK_ORDER_ROWS[0].orderNo,
                aftersaleStatus: '待确认',
                solution: '',
                onlineStatus: '等待买家退货',
                onlineType: '普通退货',
                aftersaleCategory: '退货退款',
                goodsInfo: firstGoods.goodsName + '\n商品明细  合计：1',
                returnWaybill: form.returnWaybill,
                returnInternationalWaybill: '',
                cargoStatus: '买家已收到货',
                expressInterceptStatus: '',
                operation: '编辑\n查看日志'
              }),
              goodsTableDraft: {},
              'goods-tableSelectedKeys': []
            },
            setForm: { orderCode: '', returnExpress: '', returnWaybill: '', returnWarehouse: '', remark: '', buyerSubsidy: '' },
            next: 'fasts'
          }
        }
      }] : []),
    ]
  },
  {
    id: 'leak-business',
    image: SCENE_IMAGES.leakBusiness,
    tip: '创建<span style="color:red;font-weight:bold;">漏发业务类型-补发</span>的售后单，售后问题类型选择<span style="color:red;font-weight:bold;">商品少件或破损</span>。',
    fields: ({ form }) => [
      { id: 'leak-business-search-code', model: 'orderCode', type: 'text', bgColor: '#FFFFFF', fontSize: 11, placeholder: '多个线上订单号，...', x: 0.465, y: 0.122, w: 0.08, h: 0.02 },
      ...buildLeakResendFields(form)
    ],
    tables: context => buildLeakResendTables(context, true),
    hotspots: [{
      id: 'select-leak-after-sale-issue', x: 0.196, y: 0.464, w: 0.074, h: 0.026,
      highlight: 'primary',
      set: { leakIssueSelected: true },
      next: 'leak-resend'
    }, {
      id: 'create-leak-resend-before-issue',
      x: 0.956, y: 0.962, w: 0.036, h: 0.032,
      highlight: 'primary',
      guard: () => ({ ok: false, msg: '请选择售后问题类型：商品少件或破损' })
    }]
  },
  {
    id: 'leak-resend',
    image: SCENE_IMAGES.leakResend,
    tip: '<p style="margin:0 0 8px;">售后问题类型选择<span style="color:red;font-weight:bold;">商品少发或破损</span>。选中商品编码为<span style="color:red;font-weight:bold;">' + MOCK_GOODS_ROWS[0].goodsCode + '</span>的商品，本次补发数量填写<span style="color:red;font-weight:bold;">1</span>，明细问题类型选择<span style="color:red;font-weight:bold;">应发未发</span>；</p><p style="margin:0 0 8px;">填写备注<span style="color:red;font-weight:bold;">漏发补发</span>，买家应补运费填写<span style="color:red;font-weight:bold;">0</span>，寄出快递选择<span style="color:red;font-weight:bold;">京东快递</span>。</p><p style="margin:0;">买家收货信息：“<span style="color:red;font-weight:bold;">' + EXCHANGE_RECEIVER_TEXT + '</span>”，确认地址、详细地址、联系人和联系电话后点击创建。</p>',
    tables: buildLeakResendTables,
    fields: ({ form }) => [
      { id: 'leak-resend-search-code', model: 'orderCode', type: 'text', bgColor: '#FFFFFF', fontSize: 11, placeholder: '多个线上订单号，...', x: 0.465, y: 0.122, w: 0.08, h: 0.02 },
      ...buildLeakResendFields(form)
    ],
    hotspots: [{
      id: 'create-leak-resend', x: 0.956, y: 0.962, w: 0.036, h: 0.032,
      highlight: 'primary',
      guard: ({ ui, form }) => {
        if (!ui.leakIssueSelected) return { ok: false, msg: '请选择售后问题类型：商品少件或破损' }
        const draft = ui.goodsTableDraft || {}
        const first = draft['goods-1'] || {}
        if (String(first.qty ?? 1) !== '1') return { ok: false, msg: '请填写商品 ' + MOCK_GOODS_ROWS[0].goodsCode + ' 的补发数量 1' }
        if (first.issueType !== '应发未发') return { ok: false, msg: '请选择商品 ' + MOCK_GOODS_ROWS[0].goodsCode + ' 的明细问题类型：应发未发' }
        if (!(ui['goods-tableSelectedKeys'] || []).includes('goods-1')) return { ok: false, msg: '请选中应发未发商品 ' + MOCK_GOODS_ROWS[0].goodsCode }
        const buyerSubsidy = String(form.leakBuyerSubsidy || '').trim()
        if (buyerSubsidy && buyerSubsidy !== '0') return { ok: false, msg: '无需买家承担运费' }
        if (form.leakOutExpress !== '京东快递') return { ok: false, msg: '寄出快递请选择京东快递' }
        if (!form.leakBuyerProvince || !form.leakBuyerCity || !form.leakBuyerDistrict || !form.leakBuyerDetail || !form.leakBuyerReceiver || !form.leakBuyerPhone) return { ok: false, msg: '请完成买家收货地址和收件人信息' }
        return { ok: true }
      },
      action: ({ ui }) => ({
        set: {
          createdOrders: (ui.createdOrders || []).concat({
            serialNo: (ui.createdOrders || []).length + 1,
            aftersaleNo: '售后单号：SH' + String((ui.createdOrders || []).length + 1).padStart(6, '0'),
            internalOrderNo: MOCK_ORDER_ROWS[0].orderNo,
            aftersaleStatus: '待确认', solution: '', onlineStatus: '等待补发', onlineType: '漏发补发', aftersaleCategory: '补发',
            goodsInfo: MOCK_GOODS_ROWS[0].goodsName + '\n商品明细  合计：1', returnWaybill: '', returnInternationalWaybill: '', cargoStatus: '买家未收到货', expressInterceptStatus: '', operation: '编辑\n查看日志'
          }),
          goodsTableDraft: {}, 'goods-tableSelectedKeys': [], leakIssueSelected: false, leakFlowCompleted: true
        },
        setForm: { orderCode: '', ...EMPTY_LEAK_RESEND_FORM },
        next: 'fasts-complete'
      })
    }]
  },
  {
    id: 'error-business-refund',
    image: SCENE_IMAGES.errorReturnRefund,
    tip: '',
    fields: [
      { id: 'error-business-search-code', model: 'orderCode', type: 'text', bgColor: '#FFFFFF', fontSize: 11, placeholder: '多个线上订单号，...', x: 0.465, y: 0.122, w: 0.08, h: 0.02 }
    ],
    tables: context => buildTables(context, DEFAULT_GOODS_TABLE_POSITION),
    hotspots: [{
      id: 'select-error-exchange', x: 0.295, y: 0.42, w: 0.04, h: 0.03,
      highlight: 'primary', setForm: EMPTY_ERROR_EXCHANGE_FORM, next: 'error-exchange'
    }]
  },
  { 
    id: 'resend', 
    image: SCENE_IMAGES.resend,
    tip: '<p style="margin:0 0 8px;">补发商品编号为<span style="color:red;font-weight:bold;">' + MOCK_GOODS_ROWS[0].goodsCode + '</span>的商品，填写补发数量为<span style="color:red;font-weight:bold;">1</span>。</p><p style="margin:0 0 8px;">在商品列表下方填写备注<span style="color:red;font-weight:bold;">破损补发</span>、买家应补运费<span style="color:red;font-weight:bold;">0</span>，寄出快递选择<span style="color:red;font-weight:bold;">京东快递</span>。</p><p style="margin:0;">买家收货信息“<span style="color:red;font-weight:bold;">' + EXCHANGE_RECEIVER_TEXT + '</span>”，确认买家收货地址、详细地址、联系人和联系电话后点击创建。</p>',
    tables: context => buildTables(context, _54_GOODS_TABLE_POSITION, {
      goodsType: '补',
      goodsTypeColor: '#e6a23c',
      qtyTitle: '补发数量',
      amountTitle: '补发金额',
      defaultQty: 0,
      defaultAmount: 0,
      amountInputDisabled: true
    }),
    fields: ({ form }) => [
      { id: 'search-code', model: 'orderCode', type: 'text', bgColor: '#FFFFFF', fontSize: 11, placeholder: '多个线上订单号，...', x: 0.465, y: 0.122, w: 0.08, h: 0.02 },
      ...buildResendFields(form)
    ],
    hotspots: [
      {
        id: 'create-ordinary-resend',
        x: 0.956, y: 0.962, w: 0.036, h: 0.032,
        highlight: 'primary',
        guard: ({ ui, form }) => {
          if (!(ui['goods-tableSelectedKeys'] || []).includes('goods-1')) return { ok: false, msg: '请选中要补发的商品' }
          const draft = (ui.goodsTableDraft || {})['goods-1'] || {}
          if (String(draft.qty || '') !== '1') return { ok: false, msg: '请填写补发数量 1' }
          if (form.resendOutExpress !== '京东快递') return { ok: false, msg: '寄出快递请选择京东快递' }
          if (!form.resendBuyerProvince || !form.resendBuyerCity || !form.resendBuyerDistrict || !form.resendBuyerDetail || !form.resendBuyerReceiver || !form.resendBuyerPhone) {
            return { ok: false, msg: '请完成买家收货地址和收件人信息' }
          }
          return { ok: true }
        },
        action: ({ ui }) => {
          const createdOrders = (ui.createdOrders || []).concat({
            serialNo: (ui.createdOrders || []).length + 1,
            aftersaleNo: '售后单号：SH' + String((ui.createdOrders || []).length + 1).padStart(6, '0'),
            internalOrderNo: MOCK_ORDER_ROWS[0].orderNo,
            aftersaleStatus: '待确认',
            solution: '',
            onlineStatus: '等待补发',
            onlineType: '普通补发',
            aftersaleCategory: '补发',
            goodsInfo: MOCK_GOODS_ROWS[0].goodsName + '\n商品明细  合计：1',
            returnWaybill: '',
            returnInternationalWaybill: '',
            cargoStatus: '买家未收到货',
            expressInterceptStatus: '',
            operation: '编辑\n查看日志'
          })
          return {
            set: { createdOrders, goodsTableDraft: {}, 'goods-tableSelectedKeys': [] },
            setForm: { orderCode: '', orderNo: '', buyerPhone: '' },
            next: 'fasts'
          }
        }
      }
    ]
  },
  { 
    id: 'repair', 
    image: SCENE_IMAGES.repair,
    tip: '<p style="margin:0 0 8px;"><span style="color:red;font-weight:bold;">维修业务场景：</span>针对退回商品进行货品维修处理；确认维修售后单后创建维修发货单，并在维修单据界面将维修完成的商品发给买家。售后收货和维修发货过程中<span style="color:red;font-weight:bold;">库存不变</span>。</p><p style="margin:0 0 8px;">商品处理：选中商品编码为<span style="color:red;font-weight:bold;">' + MOCK_GOODS_ROWS[0].goodsCode + '</span>的商品，维修数量填写<span style="color:red;font-weight:bold;">1</span>，维修金额填写<span style="color:red;font-weight:bold;">99</span>元。</p><p style="margin:0 0 8px;">买家寄件：退回快递公司填写<span style="color:red;font-weight:bold;">申通快递</span>，单号填写<span style="color:red;font-weight:bold;">st12654458855</span>；退货仓库选择<span style="color:red;font-weight:bold;">淘金仓库</span>，备注填写<span style="color:red;font-weight:bold;">维修返件</span>。买家应补运费<span style="color:red;font-weight:bold;">8元</span>。</p><p style="margin:0;">买家收货地址：“<span style="color:red;font-weight:bold;">' + EXCHANGE_RECEIVER_TEXT + '</span>”，确认后点击创建。</p>',
    tables: context => buildTables(context, DEFAULT_GOODS_TABLE_POSITION, {
      goodsType: '修',
      goodsTypeColor: '#e6a23c',
      qtyTitle: '维修数量',
      amountTitle: '维修金额',
      defaultQty: 0
    }),
    fields: ({ form }) => [
      { id: 'search-order-no', model: 'orderNo', type: 'text', bgColor: '#FFFFFF', fontSize: 11, placeholder: '多个订单号，以逗...', x: 0.355, y: 0.122, w: 0.085, h: 0.02 },
      ...buildRepairFields(form)
    ],
    hotspots: [
      {
        id: 'create-ordinary-repair',
        x: 0.956, y: 0.962, w: 0.036, h: 0.032,
        highlight: 'primary',
        guard: ({ ui, form }) => {
          if (!(ui['goods-tableSelectedKeys'] || []).includes('goods-1')) return { ok: false, msg: '请选中要维修的商品' }
          const draft = (ui.goodsTableDraft || {})['goods-1'] || {}
          if (String(draft.qty || '') !== '1' || String(draft.amount || '') !== '99') {
            return { ok: false, msg: '请填写维修数量 1 和维修金额 99' }
          }
          if (['returnExpress', 'returnWaybill', 'returnWarehouse'].some(key => !String(form[key] || '').trim())) return { ok: false, msg: '请完成买家寄件信息' }
          if (String(form.buyerSubsidy || '').trim() !== '8') return { ok: false, msg: '买家应补运费请填写8' }
          if (!form.buyerProvince || !form.buyerCity || !form.buyerDistrict || !form.buyerDetail || !form.buyerReceiver || !form.buyerReceiverPhone) return { ok: false, msg: '请完成买家收货地址和收件人信息' }
          return { ok: true }
        },
        action: ({ ui }) => {
          const firstGoods = { ...MOCK_GOODS_ROWS[0], ...((ui.goodsTableDraft || {})['goods-1'] || {}) }
          const createdOrders = (ui.createdOrders || []).concat({
            serialNo: (ui.createdOrders || []).length + 1,
            aftersaleNo: '售后单号：SH' + String((ui.createdOrders || []).length + 1).padStart(6, '0'),
            internalOrderNo: MOCK_ORDER_ROWS[0].orderNo,
            aftersaleStatus: '待确认',
            solution: '',
            onlineStatus: '等待买家寄回',
            onlineType: '普通维修',
            aftersaleCategory: '维修',
            goodsInfo: firstGoods.goodsName + '\n商品明细  合计：1',
            returnWaybill: '',
            returnInternationalWaybill: '',
            cargoStatus: '买家已收到货',
            expressInterceptStatus: '',
            operation: '编辑\n查看日志'
          })
          return {
            set: { createdOrders, goodsTableDraft: {}, 'goods-tableSelectedKeys': [] },
            setForm: { orderNo: '' },
            next: 'fasts'
          }
        }
      }
    ]
  },
  {
    id: 'error-return-refund',
    image: SCENE_IMAGES.errorReturnRefund,
    tip: '<span style="color:red;font-weight:bold;">选中</span>商品编码为<span style="color:red;font-weight:bold;">' + MOCK_GOODS_ROWS[0].goodsCode + '</span>的商品且标记为<span style="color:red;font-weight:bold;">应发未发</span>，然后添加错发已发商品（款式编码：<span style="color:red;font-weight:bold;">' + ERROR_PRODUCT_STYLE_CODE + '</span>）。再填入买家退回快递信息：<span style="color:red;font-weight:bold;">申通快递，单号 st12654458855</span>；退回仓库选择<span style="color:red;font-weight:bold;">淘金仓库</span>；备注填写<span style="color:red;font-weight:bold;">错发退货</span>；买家应补运费填写<span style="color:red;font-weight:bold;">0</span>。',
    tables: buildErrorReturnTables,
    fields: [
      { id: 'search-code', model: 'orderCode', type: 'text', bgColor: '#FFFFFF', fontSize: 11, placeholder: '多个线上订单号，...', x: 0.465, y: 0.122, w: 0.08, h: 0.02 },
      ...buildReturnFields()
    ],
    hotspots: [
      {
        id: 'add-error-issued-goods',
        x: 0.14, y: 0.46, w: 0.09, h: 0.03,
        highlight: 'primary',
        guard: ({ ui }) => ((ui.goodsTableDraft || {})['goods-1'] || {}).issueType === '应发未发'
          ? { ok: true }
          : { ok: false, msg: '请先将商品 ' + MOCK_GOODS_ROWS[0].goodsCode + ' 标记为应发未发' },
        set: { errorProductReturnStep: 'error-return-refund' },
        setForm: { errorProductStyleCode: '' },
        next: 'error-product-search'
      },
      {
        id: 'create-error-return-refund',
        x: 0.956, y: 0.962, w: 0.036, h: 0.032,
        highlight: 'primary',
        guard: ({ ui, form }) => {
          const drafts = ui.goodsTableDraft || {}
          const addedGoods = ui.errorAddedGoods || []
          if ((drafts['goods-1'] || {}).issueType !== '应发未发') return { ok: false, msg: '请将商品 ' + MOCK_GOODS_ROWS[0].goodsCode + ' 标记为应发未发' }
          if (!addedGoods.some(row => row.goodsCode === ERROR_PRODUCT.goodsCode && row.issueType === '错发已发')) {
            return { ok: false, msg: '请添加并标记错发已发商品 ' + ERROR_PRODUCT.goodsCode }
          }
          const required = ['returnExpress', 'returnWaybill', 'returnWarehouse']
          if (required.some(key => !String(form[key] || '').trim())) return { ok: false, msg: '请完成退回快递和仓库信息' }
          const buyerSubsidy = String(form.buyerSubsidy || '').trim()
          if (buyerSubsidy && buyerSubsidy !== '0') return { ok: false, msg: '错发无需买家承担运费' }
          const selectedKeys = ui['goods-tableSelectedKeys'] || []
          if (!selectedKeys.includes('goods-1')) return { ok: false, msg: '请选中原订单商品 ' + MOCK_GOODS_ROWS[0].goodsCode }
          return selectedKeys.includes(ERROR_PRODUCT.id)
            ? { ok: true }
            : { ok: false, msg: '请选中错发已发商品 ' + ERROR_PRODUCT.goodsCode }
        },
        action: ({ ui, form }) => {
          const firstGoods = { ...MOCK_GOODS_ROWS[0], ...((ui.goodsTableDraft || {})['goods-1'] || {}) }
          const createdOrders = (ui.createdOrders || []).concat({
            serialNo: (ui.createdOrders || []).length + 1,
            aftersaleNo: '售后单号：SH' + String((ui.createdOrders || []).length + 1).padStart(6, '0'),
            internalOrderNo: MOCK_ORDER_ROWS[0].orderNo,
            aftersaleStatus: '待确认',
            solution: '',
            onlineStatus: '等待买家退货',
            onlineType: '错发退货',
            aftersaleCategory: '退货退款',
            goodsInfo: firstGoods.goodsName + '\n商品明细  合计：1',
            returnWaybill: form.returnWaybill,
            returnInternationalWaybill: '',
            cargoStatus: '买家已收到货',
            expressInterceptStatus: '',
            operation: '编辑\n查看日志'
          })
          return {
            set: { createdOrders, goodsTableDraft: {}, 'goods-tableSelectedKeys': [], errorAddedGoods: [], errorProductReturnStep: '', errorFlow: 'refund' },
            setForm: { returnExpress: '', returnWaybill: '', returnWarehouse: '', remark: '', buyerSubsidy: '' },
            next: 'fasts'
          }
        }
      }
    ]
  },
  {
    id: 'error-product-search',
    image: SCENE_IMAGES.errorProductSearch,
    tip: '在本地商品库中搜索款式编码为<span style="color:red;font-weight:bold;">' + ERROR_PRODUCT_STYLE_CODE + '</span>的错发已发商品。',
    labels: productSearchLabels,
    tables: () => buildProductSearchTable(false),
    fields: [
      { id: 'error-product-style-code', model: 'errorProductStyleCode', type: 'text', bgColor: '#FFFFFF', fontSize: 10, placeholder: '款式编码', x: 0.42, y: 0.257, w: 0.09, h: 0.026 }
    ],
    hotspots: [{
      id: 'search-error-product', x: 0.743, y: 0.292, w: 0.033, h: 0.03, highlight: 'primary',
      guard: ({ form }) => (form.errorProductStyleCode || '').trim().toUpperCase() === ERROR_PRODUCT_STYLE_CODE.toUpperCase()
        ? { ok: true }
        : { ok: false, msg: '请输入正确的款式编码 ' + ERROR_PRODUCT_STYLE_CODE },
      set: { 'error-product-search-tableSelectedKeys': [] },
      next: 'error-product-search-result'
    }]
  },
  {
    id: 'error-product-search-result',
    image: SCENE_IMAGES.errorProductSearchResult,
    tip: '选中商品编码为<span style="color:red;font-weight:bold;">' + ERROR_PRODUCT.goodsCode + '</span>的商品并确认添加。',
    labels: productSearchLabels,
    tables: () => buildProductSearchTable(true),
    fields: [
      { id: 'error-product-style-code-result', model: 'errorProductStyleCode', type: 'text', bgColor: '#FFFFFF', fontSize: 11, placeholder: '款式编码', x: 0.42, y: 0.255, w: 0.09, h: 0.026 }
    ],
    hotspots: [{
      id: 'confirm-error-product', x: 0.786, y: 0.622, w: 0.035, h: 0.032, highlight: 'primary',
      guard: ({ ui }) => {
        if (!(ui['error-product-search-tableSelectedKeys'] || []).includes(ERROR_PRODUCT.id)) return { ok: false, msg: '请选择要添加的商品' }
        if (MOCK_GOODS_ROWS.concat(ui.errorAddedGoods || []).some(row => row.goodsCode === ERROR_PRODUCT.goodsCode)) {
          return { ok: false, msg: '该商品已在商品库中，不能重复添加' }
        }
        return { ok: true }
      },
      action: ({ ui }) => ({
        set: {
          errorAddedGoods: (ui.errorAddedGoods || []).concat(ERROR_PRODUCT),
          'error-product-search-tableSelectedKeys': []
        },
        next: ui.errorProductReturnStep || 'error-return-refund'
      })
    }]
  },
  {
    id: 'error-exchange',
    image: SCENE_IMAGES.errorExchange,
    tip: '<p style="margin:0 0 8px;">商品处理：将商品编码为<span style="color:red;font-weight:bold;">' + MOCK_GOODS_ROWS[0].goodsCode + '</span>的商品标记为<span style="color:red;font-weight:bold;">应发未发</span>，并添加款式编码为<span style="color:red;font-weight:bold;">' + ERROR_PRODUCT_STYLE_CODE + '</span>的错发已发商品；再添加要换商品，必须选择商品编码为<span style="color:red;font-weight:bold;">' + MOCK_GOODS_ROWS[0].goodsCode + '</span>的商品。</p><p style="margin:0 0 8px;">退回信息：快递公司填写<span style="color:red;font-weight:bold;">申通快递</span>，单号填写<span style="color:red;font-weight:bold;">st12654458855</span>；退回仓库选择<span style="color:red;font-weight:bold;">淘金仓库</span>，备注填写<span style="color:red;font-weight:bold;">错发换货</span>。</p><p style="margin:0 0 8px;">寄出信息：买家应补运费填写<span style="color:red;font-weight:bold;">0</span>，寄出快递选择<span style="color:red;font-weight:bold;">京东快递</span>。</p><p style="margin:0 0 8px;">收件人信息：“<span style="color:red;font-weight:bold;">' + EXCHANGE_RECEIVER_TEXT + '</span>”。</p><p style="margin:0;">完成后点击<span style="color:red;font-weight:bold;">创建</span>。</p>',
    tables: buildErrorExchangeTables,
    fields: ({ form }) => [
      { id: 'search-code', model: 'orderCode', type: 'text', bgColor: '#FFFFFF', fontSize: 11, placeholder: '多个线上订单号，...', x: 0.465, y: 0.122, w: 0.08, h: 0.02 },
      ...buildErrorExchangeFields(form)
    ],
    hotspots: [{
      id: 'add-error-issued-goods-exchange', x: 0.14, y: 0.46, w: 0.09, h: 0.03, highlight: 'primary',
      guard: ({ ui }) => ((ui.goodsTableDraft || {})['goods-1'] || {}).issueType === '应发未发'
        ? { ok: true }
        : { ok: false, msg: '请先将商品 ' + MOCK_GOODS_ROWS[0].goodsCode + ' 标记为应发未发' },
      set: { errorProductReturnStep: 'error-exchange' },
      setForm: { errorProductStyleCode: '' },
      next: 'error-product-search'
    }, {
      id: 'add-exchange-goods', x: 0.335, y: 0.46, w: 0.09, h: 0.03, highlight: 'primary',
      next: 'exchange-product-select'
    }, {
      id: 'create-error-exchange', x: 0.956, y: 0.962, w: 0.036, h: 0.032, highlight: 'primary',
      guard: ({ ui, form }) => {
        const drafts = ui.goodsTableDraft || {}
        if ((drafts['goods-1'] || {}).issueType !== '应发未发') return { ok: false, msg: '请将原商品标记为应发未发' }
        if (!(ui.errorAddedGoods || []).some(row => row.goodsCode === ERROR_PRODUCT.goodsCode)) return { ok: false, msg: '请添加错发已发商品' }
        if (!(ui.exchangeAddedGoods || []).some(row => row.goodsCode === MOCK_GOODS_ROWS[0].goodsCode && row.issueType === '无')) return { ok: false, msg: '请添加要换商品' }
        const selectedKeys = ui['goods-tableSelectedKeys'] || []
        if (!selectedKeys.includes('goods-1')) return { ok: false, msg: '请选中应发未发商品 ' + MOCK_GOODS_ROWS[0].goodsCode }
        if (!selectedKeys.includes(ERROR_PRODUCT.id)) return { ok: false, msg: '请选中错发已发商品 ' + ERROR_PRODUCT.goodsCode }
        if (!selectedKeys.includes(EXCHANGE_PRODUCT.id)) return { ok: false, msg: '请选中要换商品 ' + EXCHANGE_PRODUCT.goodsCode }
        if (['returnExpress', 'returnWaybill', 'returnWarehouse'].some(key => !String(form[key] || '').trim())) return { ok: false, msg: '请完成买家退回信息' }
        const buyerSubsidy = String(form.buyerSubsidy || '').trim()
        if (buyerSubsidy && buyerSubsidy !== '0') return { ok: false, msg: '无需买家承担运费' }
        if (form.outExpress !== '京东快递') return { ok: false, msg: '寄出快递请选择京东快递' }
        if (!form.buyerProvince || !form.buyerCity || !form.buyerDistrict || !form.buyerDetail || !form.buyerReceiver || !form.buyerReceiverPhone) return { ok: false, msg: '请完成买家收货地址和收件人信息' }
        return { ok: true }
      },
      action: ({ ui, form }) => ({
        set: { createdOrders: (ui.createdOrders || []).concat({
          serialNo: (ui.createdOrders || []).length + 1, aftersaleNo: '售后单号：SH' + String((ui.createdOrders || []).length + 1).padStart(6, '0'),
          internalOrderNo: MOCK_ORDER_ROWS[0].orderNo, aftersaleStatus: '待确认', solution: '', onlineStatus: '等待买家退货', onlineType: '错发换货', aftersaleCategory: '换货',
          goodsInfo: MOCK_GOODS_ROWS[0].goodsName + '\n商品明细  合计：3', returnWaybill: form.returnWaybill, returnInternationalWaybill: '', cargoStatus: '买家已收到货', expressInterceptStatus: '', operation: '编辑\n查看日志'
        }), goodsTableDraft: {}, 'goods-tableSelectedKeys': [], errorAddedGoods: [], exchangeAddedGoods: [], errorProductReturnStep: '', errorFlow: '' },
        next: 'fasts'
      })
    }]
  },
  {
    id: 'exchange-product-select',
    image: SCENE_IMAGES.exchangeProductSelect,
    tip: '选择商品编码为<span style="color:red;font-weight:bold;">' + MOCK_GOODS_ROWS[0].goodsCode + '</span>的要换商品并确认添加。',
    tables: buildExchangeProductSelectTable,
    hotspots: [{
      id: 'confirm-exchange-product', x: 0.786, y: 0.436, w: 0.035, h: 0.032, highlight: 'primary',
      guard: ({ ui }) => (ui['exchange-product-select-tableSelectedKeys'] || []).includes('goods-1')
        ? { ok: true }
        : { ok: false, msg: '请选择商品编码 ' + MOCK_GOODS_ROWS[0].goodsCode },
      action: () => ({ set: { exchangeAddedGoods: [EXCHANGE_PRODUCT], 'exchange-product-select-tableSelectedKeys': [] }, next: 'error-exchange' })
    }]
  }
]

export function getJstErpSecondScenario() {
  return {
    initialStepId: 'fasts',
    initialForm: { orderCode: '' },
    steps: SECOND_CHAPTER_STEPS.map(step => ({
      ...step,
      tip: getSecondChapterTip,
      aspectRatio: 1912 / 956
    }))
  }
}



// WEBPACK FOOTER //
// ./src/page/simulate/jushuitan/jstErpSecondScenarios.js